import { useEffect } from "react";
import Navigation from "./Navigation";
import Footer from "./Footer";
import { Toaster } from "@/components/ui/sonner";
import { trackEvent } from "../../lib/analytics";

export default function Layout({ children, pageName }) {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "auto" });
    if (pageName) {
      trackEvent("page_view", { meta: { page: pageName } });
    }
    // trackEvent is a module-scope pure function and does not need to be in deps
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageName]);

  return (
    <div className="bg-cream text-charcoal min-h-screen flex flex-col">
      <Navigation />
      <main className="flex-1">{children}</main>
      <Footer />
      <Toaster position="top-right" richColors closeButton />
    </div>
  );
}
